<template>
    <b-container>
        <router-view></router-view>
    </b-container>
</template>

<script>
    import './assets/style.scss'
    import Vue from 'vue';
    import BootstrapVue from "bootstrap-vue";
    import VueMoment from "vue-moment";

    const moment = require('moment');
    require('moment/locale/fr');
    moment.locale('fr');

    Vue.use(BootstrapVue);
    Vue.use(VueMoment, {
        moment
    });

    export default {
        name: 'app'
    }
</script>

<style lang="scss">
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        margin-top: 60px;
    }
</style>
